import { ONEWAY, ROUNDTRIP } from '../constants/tripConstants';
import { isFlightOrPackageLOB } from './suggestionsUtils';

export const getTripType = (isRoundTrip) => (isRoundTrip ? ROUNDTRIP : ONEWAY);

export const getAnalyticsUtils = ({
  type,
  lob,
  isRoundTrip,
  suggestionIndex,
}) => {
  const suggestionType = type?.toLowerCase() || '';
  const lobType = `${lob?.charAt(0)}${lob?.toLowerCase()?.slice(1)}`;
  const tripType = isFlightOrPackageLOB(lob) ? getTripType(isRoundTrip) : '';
  if (suggestionIndex) {
    return `${suggestionType}${lobType}${suggestionIndex}${tripType}`;
  }
  return `${suggestionType}${lobType}${tripType}`;
};
